import { Link } from "react-router-dom";
import {BookOpen, Mail, ArrowUp} from 'lucide-react';

export default function Footer() {
  const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <footer className="bg-zinc-50 dark:bg-zinc-950 border-t border-zinc-200 dark:border-zinc-800/50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-3 mb-4">
              <BookOpen size={22} className="text-[#C5A572]" />
              <span className="font-serif text-lg font-semibold text-zinc-900 dark:text-white">
                M. A. AMIN Books
              </span>
            </Link>
            <p className="text-sm text-zinc-500 dark:text-zinc-400 leading-relaxed">
              Home to the fiction and non-fiction works of Muhammad Awais Amin.
            </p>
            <p className="mt-3 text-xs tracking-wider text-[#C5A572] uppercase">
              Stories · Knowledge · Legacy
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="font-serif text-sm font-semibold uppercase tracking-wider text-zinc-900 dark:text-white mb-4">
              Navigate
            </h4>
            <div className="flex flex-col gap-2.5">
              {[
                { to: "/", label: "Home" },
                { to: "/library", label: "Library" },
                { to: "/fiction", label: "Fiction" },
                { to: "/non-fiction", label: "Non-Fiction" },
                { to: "/about", label: "Author" },
                { to: "/blog", label: "Journal" },
                { to: "/contact", label: "Contact" },
              ].map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  className="text-sm text-zinc-500 dark:text-zinc-400 hover:text-[#C5A572] dark:hover:text-[#C5A572] transition-colors duration-300"
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>

          {/* Books */}
          <div>
            <h4 className="font-serif text-sm font-semibold uppercase tracking-wider text-zinc-900 dark:text-white mb-4">
              Current Works
            </h4>
            <div className="flex flex-col gap-2.5">
              {[
                { to: "/book/ashes-and-oaths", label: "Ashes & Oaths" },
                { to: "/book/the-gathering", label: "The Gathering" },
                { to: "/book/gold-and-amber", label: "Gold & Amber" },
                { to: "/book/3-cups-on-the-rooftop", label: "3 Cups on the Rooftop" },
                { to: "/book/lives-of-the-prophets", label: "Lives of the Prophets (AS)" },
              ].map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  className="text-sm text-zinc-500 dark:text-zinc-400 hover:text-[#C5A572] dark:hover:text-[#C5A572] transition-colors duration-300"
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-serif text-sm font-semibold uppercase tracking-wider text-zinc-900 dark:text-white mb-4">
              Connect
            </h4>
            <a
              href="mailto:contact@maaminbooks.com"
              className="flex items-center gap-2 text-sm text-zinc-500 dark:text-zinc-400 hover:text-[#C5A572] dark:hover:text-[#C5A572] transition-colors duration-300 mb-3"
            >
              <Mail size={14} />
              contact@maaminbooks.com
            </a>
            <p className="text-xs text-zinc-400 dark:text-zinc-500 leading-relaxed">
              Reader inquiries, beta reading, review requests, and publishing discussions welcome.
            </p>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-12 pt-8 border-t border-zinc-200 dark:border-zinc-800/50 flex items-center justify-between">
          <p className="text-xs text-zinc-400 dark:text-zinc-500">
            &copy; {new Date().getFullYear()} M. A. AMIN Books. All rights reserved.
          </p>
          <button
            onClick={scrollToTop}
            className="p-2 rounded-full text-zinc-400 hover:text-[#C5A572] hover:bg-zinc-100 dark:hover:bg-zinc-800/50 transition-all duration-300"
            aria-label="Scroll to top"
          >
            <ArrowUp size={16} />
          </button>
        </div>
      </div>
    </footer>
  );
}
